import ResellerAdd from "../pages/reseller/add_reseller/index";
import ResellerList from "../pages/reseller/reseller_list/index";
import DashboardPageLayout from "../layouts/dashboard_layout";
import { ProtectedRoutes } from "./protected_route";

const ResellerRoutes = {
  path: "/reseller",
  element: (
    <ProtectedRoutes>
      <DashboardPageLayout />
    </ProtectedRoutes>
  ),
  children: [
    {
      index: true,
      element: <ResellerList />,
    },
    {
      path: "add",
      element: <ResellerAdd />,
    },
  ],
};

export default ResellerRoutes;
